function convertPointModel(data) {
  let point = {
    Id: data.id,
    CategoryCode: data.categoryCode,
    CategoryName: data.categoryName,
    PercentPoint: data.percentPoint || 0,
    HundredPercentPoint: data.percentPoint
      ? Number(Number(data.percentPoint * 100).toFixed(0))
      : 0,
    ValuePoint: data.valuePoint || 0,
    ProgramId: data.programId,
    ProgramName: data.programName,
    SubCategories: data.programSubCategoryPoints || [],
    IsLock: Boolean(data.locked) || false
  };
  return point;
}

function convertPointRawModel(data) {
  let point = {
    categoryCode: data.CategoryCode,
    categoryName: data.CategoryName,
    percentPoint: data.HundredPercentPoint ? data.HundredPercentPoint / 100 : 0,
    valuePoint: data.ValuePoint || 0,
    programId: data.ProgramId,
    locked: data.IsLock || false
  };
  if (data.Id > 0) {
    point.id = data.Id;
  }
  if (data.SubCategories && data.SubCategories.length > 0) {
    point.programSubCategoryPoints = convertListSubPointRawModel(
      data.SubCategories
    );
  }
  return point;
}

function convertListPointModel(data) {
  let listPoint = [];
  data.forEach(item => {
    if (
      item.programSubCategoryPoints &&
      item.programSubCategoryPoints.length > 0
    ) {
      let listSub = convertListSubPointModel(
        item.programSubCategoryPoints,
        item.categoryCode
      );
      item.programSubCategoryPoints = listSub;
    }
    listPoint.push(convertPointModel(item));
  });
  return listPoint;
}

function convertListPointRawModel(data) {
  let listPoint = [];
  data.forEach(item => {
    listPoint.push(convertPointRawModel(item));
  });
  return listPoint;
}

function convertSubPointModel(data, categoryCode) {
  let point = {
    Id: data.id,
    CategoryCode: data.code,
    CategoryName: data.name,
    PercentPoint: data.percentPoint,
    HundredPercentPoint: data.percentPoint
      ? Number(Number(data.percentPoint * 100).toFixed(0))
      : 0,
    ValuePoint: data.valuePoint,
    CompletionsCap: data.completionsCap,
    CategoryId: data.programCategoryPointId,
    IsLock: data.locked || false
  };
  point.IsEditCompletionCap = true;
  if (
    categoryCode === "WELLMETRICS" &&
    data.code !== "WELlMETRIC_SCREENNING" &&
    data.code !== "WELLMETRIC_REGISTRATION"
  ) {
    point.IsEditCompletionCap = false;
  }
  return point;
}

function convertSubPointRawModel(data) {
  let point = {
    code: data.CategoryCode,
    name: data.CategoryName,
    percentPoint: data.HundredPercentPoint ? data.HundredPercentPoint / 100 : 0,
    valuePoint: data.ValuePoint || 0,
    completionsCap: data.CompletionsCap || 1,
    programCategoryPointId: data.CategoryId,
    locked: data.IsLock || false
  };
  if (data.Id > 0) {
    point.id = data.Id;
  }
  return point;
}

function convertListSubPointRawModel(data) {
  let list = [];
  data.forEach(item => {
    list.push(convertSubPointRawModel(item));
  });
  return list;
}

function convertListSubPointModel(data, categoryCode) {
  let listSub = [];
  data.forEach(item => {
    listSub.push(convertSubPointModel(item, categoryCode));
  });
  return listSub;
}

function convertCategoryModel(data) {
  let category = {
    Id: data.id,
    CategoryCode: data.code,
    CategoryName: data.name,
    SubCategories: convertListSubCategoryModel(data.subCategories, data.id)
  };
  return category;
}

function convertListCategoryModel(data) {
  let list = [];
  data.forEach(item => {
    list.push(convertCategoryModel(item));
  });
  return list;
}

function convertSubCategoryModel(data, categoryId) {
  let category = {
    Id: data.id,
    CategoryCode: data.code,
    CategoryName: data.name
  };
  if (categoryId && categoryId > 0) {
    category.CategoryId = categoryId;
  }
  return category;
}

function convertListSubCategoryModel(data, categoryId) {
  let list = [];
  data.forEach(item => {
    list.push(convertSubCategoryModel(item, categoryId));
  });
  return list;
}

export default {
  convertPointModel,
  convertPointRawModel,
  convertListPointModel,
  convertListPointRawModel,
  convertSubPointModel,
  convertSubPointRawModel,
  convertListSubPointModel,
  convertCategoryModel,
  convertListCategoryModel,
  convertListSubCategoryModel
};



// WEBPACK FOOTER //
// ./src/store/modules/basic_program_points/transform.js